




















































































import Login from '@/components/common/Login.vue';
import RedirectModal from '@/components/common/RedirectModal.vue';
import Autocomplete from '@/components/form/Autocomplete.vue';
import LoginMutation from '@/graphql/mutations/login.gql';
import RequestQuoteMutation from '@/graphql/mutations/requestQuote.gql';
import SignUpMutation from '@/graphql/mutations/signUp.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Autocomplete,
    Login,
    RedirectModal,
  },
})
export default class RequestQuote extends Vue {
  @Prop() public showClass!: string;
  @Prop() public showText!: string;

  public airports = require('../assets/airports.json');
  public email: string = '';
  public password: string = '';
  public name: string = '';
  public minDepartureDate: string = '';
  public isAdditionalPerson: boolean = false;
  public departingAirport: string = '';
  public agreements: boolean = false;
  public errorMessage: string = '';
  public createdNewUser: boolean = false;
  public newUserNotification: string = '';
  public redirectActive: boolean = false;
  public minDepartureDates = [
    {
      text: '2 weeks from now',
      value: new Date(Date.now() + 1.21e9).toISOString(),
    },
    {
      text: '1 month from now',
      value: new Date(Date.now() + 2.628e9).toISOString(),
    },
    {
      text: '2 months from now',
      value: new Date(Date.now() + 5.256e9).toISOString(),
    },
    {
      text: '3 months from now',
      value: new Date(Date.now() + 7.884e9).toISOString(),
    },
  ];

  public requestQuote() {
    const clinicId = this.$store.getters['cart/clinic'];
    const procedureIds = this.$store.getters['cart/procedures'];
    const minDepartureDate = this.minDepartureDate;

    this.signUpIfNeeded()
      .then(() => {
        if (this.createdNewUser) {
          this.newUserNotification =
            'Your account has been successfully created.';
        }
        if (this.minDepartureDate === '' || this.departingAirport === '') {
          throw [
            new Error(
              'Please fill out your earliest departure time and home airport.'
            ),
          ];
        }
        return request(RequestQuoteMutation, {
          clinicId,
          procedureIds,
          minDepartureDate,
          additionalTravelers: +this.isAdditionalPerson,
          departingAirport: this.departingAirport,
        });
      })
      .then(({ errors }: any) => {
        if (errors && errors.length) {
          throw [new Error('Something went wrong. Please try again later.')];
        }
      })
      .then(() => {
        this.redirectActive = true;
      })
      .catch((errors: any) => {
        const error = this.parseErrors(errors);
        this.errorMessage = error;
      });
  }

  public clearCart() {
    this.$store.dispatch('cart/clear');
  }

  private parseErrors(errors: any) {
    const err = errors && errors[0];
    if (!err) {
      return 'Something went wrong. Please try again later.';
    }

    const msg = err.message || err;
    return typeof msg === 'string'
      ? msg
      : msg.error || 'Something went wrong. Please try again later.';
  }

  private async signUpIfNeeded() {
    if (this.$store.getters['auth/authenticated']) {
      return;
    }

    if (
      this.email.length < 1 ||
      this.password.length < 1 ||
      this.name.length < 1
    ) {
      throw [new Error('Please fill out all fields.')];
    }

    if (!this.agreements) {
      throw [
        new Error(
          'You must agree to the Remeco Care Terms and Conditions and Privacy Policy.'
        ),
      ];
    }

    const { errors } = await request(SignUpMutation, {
      email: this.email,
      password: this.password,
      name: this.name,
      checkboxText:
        'I have read and agree to the Remeco Care Terms and Conditions and Privacy Policy',
    });
    if (errors && errors.length) {
      throw errors;
    }

    const { data, errors: loginErrors } = await request(LoginMutation as any, {
      email: this.email,
      password: this.password,
    });
    const token = data && data.beginSession.sessionToken;
    if (token) {
      this.$store.dispatch('auth/setAuthToken', token);
      this.createdNewUser = true;
    } else {
      throw loginErrors;
    }
  }
}
